<template>
  <a :href="url" class="p-point-notification-panel-small" v-touch:tap>
    <div class="p-point-notification-panel-small__icon">
      <slot name="icon" />
    </div>
    <div class="p-point-notification-panel-small__content">
      <p class="p-point-notification-panel-small__title">
        <slot name="title" />
      </p>
      <div class="p-point-notification-panel-small__detail">
        <slot name="detail" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.p-point-notification-panel-small {
  height: rem(118);
  padding: rem(12) rem(24) rem(12) rem(12);
  border-radius: px(4);
  display: flex;
  align-items: center;
  justify-content: center;

  &.tap {
    opacity: 0.5;
  }

  &__content {
    margin-left: rem(16);
  }

  &__title {
    @include text__body--l;
    width: max-content;
    max-width: rem(190);
    overflow-wrap: break-word;
    line-height: rem(24);
    color: $common-white;
    margin-bottom: rem(8);
    white-space: pre-wrap;
  }
}

.p-point-notification-panel-small:hover {
  opacity: 0.5;
}
</style>
